import { FC } from 'react'
import {
  Box,
  BoxProps,
  LinearProgress,
  LinearProgressProps,
} from '@mui/material'

type LoadedLoadingBarProps = {
  fullWidth?: boolean
  boxProps?: BoxProps
  linearProgressProps?: LinearProgressProps
}

const LoadedLoadingBar: FC<LoadedLoadingBarProps> = ({
  fullWidth = false,
  boxProps,
  linearProgressProps,
}) => {
  const width = fullWidth ? '100%' : '25%'
  return (
    <Box
      sx={{
        width: width,
        marginLeft: 'auto',
        marginRight: 'auto',
        ...boxProps?.sx,
      }}
      {...boxProps}
    >
      <LinearProgress {...linearProgressProps} />
    </Box>
  )
}

export default LoadedLoadingBar
